import { lazy, Suspense, type ComponentProps } from 'react';
import { Skeleton } from '@/components/ui/feedback';

/**
 * Recharts is the one heavy dependency and only two screens draw with it, so
 * the bar charts load on first use rather than with the app. The skeleton is
 * the height the chart will be, so nothing jumps.
 */
const HBarsInner = lazy(() => import('./bars').then((m) => ({ default: m.HBars })));
const DivergingInner = lazy(() => import('./bars').then((m) => ({ default: m.DivergingBars })));

const height = (n: number) => `${n * 28 + 8}px`;

export function HBars(props: ComponentProps<typeof HBarsInner>) {
  return <Suspense fallback={<Skeleton style={{ height: height(props.data.length || 3) }} />}><HBarsInner {...props} /></Suspense>;
}

export function DivergingBars(props: ComponentProps<typeof DivergingInner>) {
  return <Suspense fallback={<Skeleton style={{ height: height(props.data.length || 3) }} />}><DivergingInner {...props} /></Suspense>;
}
